import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AgreementPriceService {

    private priceChangeSubject = new Subject<void>();

    priceChange$: Observable<void> = this.priceChangeSubject.asObservable();

    notifyPriceChanged(): void {
        this.priceChangeSubject.next();
    }
}   